/**
 * NIKA: ред "Доставка" в сумите на количката + обща сума със включена доставка.
 *
 * Цената идва от nika-shipping-estimator чрез събитието
 * `nika:shipping-estimated` — публикува се методът, който клиентът е избрал
 * с радио бутона. При 0 → "Безплатна".
 *
 * Живее в отделен файл, зареден от theme.liquid, защото дроуерът на количката
 * се вгражда чрез morph, а inline <script> в morph-нат HTML НЕ се изпълнява.
 *
 * ВНИМАНИЕ (научено по трудния начин): този скрипт променя същия DOM, който
 * наблюдава. Затова наблюдателят се спира преди всяка промяна и се пуска след
 * нея, а render() излиза рано, ако няма какво да се промени. Без това
 * страницата влиза в безкраен цикъл и браузърът забива.
 */
(function () {
  if (window.__nikaShipTotal) return;
  window.__nikaShipTotal = true;

  var STORAGE = 'nika-ship-total';
  var state = null; /* { price, formatted, name } или null */
  var busy = false;

  try {
    var saved = sessionStorage.getItem(STORAGE);
    if (saved) state = JSON.parse(saved);
  } catch (e) {
    /* без запомняне */
  }

  var fmt = { format: function (n) { var p = Number(n).toFixed(2).split('.'); return p[0].replace(/\B(?=(\d{3})+(?!\d))/g, '\u00A0') + ',' + p[1] + '\u00A0€'; } };

  var observer = new MutationObserver(schedule);
  var observed = new WeakSet();
  var pending = null;

  function schedule() {
    if (busy) return;
    clearTimeout(pending);
    pending = setTimeout(render, 80);
  }

  function observe() {
    document.querySelectorAll('.cart-totals').forEach(function (el) {
      if (observed.has(el)) return;
      observed.add(el);
      observer.observe(el, { childList: true, subtree: true });
    });
  }

  function totalValueEl(container) {
    return container.querySelector('.cart-totals__total-value:not(.nika-ship-row__value)');
  }

  function cartTotalCents(container) {
    var n = parseInt(container.getAttribute('data-nika-cart-total'), 10);
    return isNaN(n) ? null : n;
  }

  function renderOne(container) {
    var totalRow = container.querySelector('.cart-totals__total');
    if (!totalRow) return;

    var row = container.querySelector('.nika-ship-row');

    if (!state) {
      if (row) row.remove();
      var el0 = totalValueEl(container);
      if (el0 && el0.dataset.nikaOriginal && el0.textContent.trim() !== el0.dataset.nikaOriginal) {
        el0.textContent = el0.dataset.nikaOriginal;
      }
      return;
    }

    if (!row) {
      row = document.createElement('span');
      row.className = 'cart-totals__item nika-ship-row';
      row.innerHTML =
        '<span class="cart-totals__total-label cart-primary-typography nika-ship-row__label"></span>' +
        '<span class="cart-totals__total-value cart-secondary-typography nika-ship-row__value"></span>';
      totalRow.parentNode.insertBefore(row, totalRow);
    }

    var free = !(state.price > 0);
    var labelEl = row.querySelector('.nika-ship-row__label');
    var valEl = row.querySelector('.nika-ship-row__value');
    var wantLabel = 'Доставка';
    var wantVal = free ? 'Безплатна' : state.formatted;
    if (labelEl.textContent !== wantLabel) labelEl.textContent = wantLabel;
    if (valEl.textContent !== wantVal) valEl.textContent = wantVal;
    valEl.classList.toggle('nika-ship-row__value--free', free);

    var el = totalValueEl(container);
    var cents = cartTotalCents(container);
    if (!el || cents === null) return;
    if (!el.dataset.nikaOriginal) el.dataset.nikaOriginal = el.textContent.trim();
    var text = fmt.format(cents / 100 + (free ? 0 : state.price));
    if (el.textContent.trim() !== text) el.textContent = text;
  }

  function render() {
    if (busy) return;
    busy = true;
    observer.disconnect();
    observed = new WeakSet();
    try {
      document.querySelectorAll('.cart-totals__container').forEach(renderOne);
    } finally {
      observe();
      busy = false;
    }
  }

  document.addEventListener('nika:shipping-estimated', function (e) {
    state = e.detail || null;
    try {
      if (state) sessionStorage.setItem(STORAGE, JSON.stringify(state));
      else sessionStorage.removeItem(STORAGE);
    } catch (err) {
      /* ignore */
    }
    render();
  });

  /* количката се появява/презарежда динамично — следим само дали е
     възникнал нов .cart-totals, с рядка проверка и без верижни render-и */
  var lastCount = -1;
  setInterval(function () {
    var n = document.querySelectorAll('.cart-totals__container').length;
    if (n !== lastCount) {
      lastCount = n;
      if (n > 0) render();
    }
  }, 600);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', render);
  } else {
    render();
  }
})();
